import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

const AUCUN_COMPTE = {};

/**
 * Nombre de questions écrites à la main, par attendu, pour les attendus d'un
 * niveau (2026-09-29) : les badges du panneau quand il montre un AUTRE niveau
 * que la classe. Le serveur compte, rien n'est téléchargé de la banque.
 * Réponse { "601": 6, "602": 3 } ; `niveauAttendu` : '6eme', '5eme'…
 * Un appel quand le niveau devient actif, puis seulement quand `refresh`
 * change (création ou suppression d'une question) : rouvrir le panneau sur le
 * même niveau ne redemande rien, les nombres n'ont pas pu bouger.
 * Tant que la route n'est pas déployée, la réponse reste vide : les badges ne
 * montrent alors que les exerciseurs, sans erreur à l'écran.
 */
export const useComptesQuestionsParAttendu = (niveauAttendu, actif, refresh) => useApi(
    `${url}banque-questions/compte-par-attendu/?niveau_attendu=${niveauAttendu}`,
    AUCUN_COMPTE,
    refresh,
    actif && niveauAttendu ? undefined : 'not-enabled',
);
